const CartSlider = {  
  /**
   * Initialize 
   */
  init: function() {
    this._sliderContainer = 'cart-slider-container';
    this._sliderShadow = 'cart-slider-back-shadow';
    this._sliderCloseIcon = 'cart-slider-close-icon';
    this._blockOverflowClass = 'cart-slider-block-scroll';
    this._sliderCartWrapper = 'cart-slider-wrapper';
    this._roleRemove = '[data-role="remove-action"]';
    this._roleQtyPlus = '[data-role="increase-action"]';
    this._roleQtyMinus = '[data-role="decrease-action"]';
    this._roleQtyInput = '[data-role="quantity"]';
    this._roleCartBag = '[data-role="cart-bag"]';
    this._roleCartBagQty = '[data-role="cart-bag-count"]';
    this._keyQueueCartUpdate = null;
    this._timeWait = 2000;
    this.bindActions();
    this.replaceAddToCart();
  },
  /**
   * Do XHR request
   * @param {String} path 
   * @param {Object} data 
   * @returns Response
   */
  post: async function(path, data) {
    return await fetch(path, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(data)
    });
  },
  /**
   * Open cart slider
   * @param {Boolean} anim 
   */
  open: function(anim = true) {    
    document.getElementById(this._sliderShadow).style.display = 'block';
    document.body.classList.add(this._blockOverflowClass);

    let container = document.getElementById(this._sliderContainer);
    if (anim) {
      container.classList.add('anim');
    } else {
      container.classList.remove('anim');
    }
    container.style.display = 'block';
  },
  /**
   * Close cart slider
   */
  close: function() {
    document.getElementById(this._sliderShadow).style.display = 'none';
    document.getElementById(this._sliderContainer).style.display = 'none';
    document.body.classList.remove(this._blockOverflowClass);
  },
  /**
   * Start Loading
   */
  startLoading: function() {
    document.getElementById('cart-slider-loading').classList.remove('abs-hide');
  },
  /**
   * Remove an item from the cart
   * @param {Integer} lineItemId 
   */
  removeItem: async function(lineItemId) {
    this.startLoading();
    let data = { updates: {} };
    data.updates[lineItemId] = 0;
    await this.post('/cart/update.js', data);
    this.refreshCart();
  },
  /**
   * Get item quantity input
   * @param {Integer} lineItemId 
   * @returns {Object}
   */
  getQtyInput: function(lineItemId) {
    return document.querySelector(this._roleQtyInput + '[data-target="' + lineItemId + '"]');
  },
  /**
   * Get item quantity from line item
   * @param {Integer} lineItemId 
   * @returns Integer
   */
  getItemQty: function(lineItemId) {
    let input = this.getQtyInput(lineItemId);
    return parseInt(input.value);
  },
  /**
   * Change item quantity
   * @param {Integer} lineItemId 
   * @param {Integer} qty 
   */
  updateItems: async function() {
    this.startLoading();
    let data = { updates: {} };
    document.querySelectorAll(this._roleQtyInput).forEach(function (input) {
      let key = input.getAttribute('data-target');
      data.updates[key] = parseInt(input.value);
    });
    
    await this.post('/cart/update.js', data);
    this.refreshCart();
  },
  /**
   * Queue cart update
   */
  queueUpdateItems: function () {    
    clearTimeout(this._keyQueueCartUpdate);
    var self4 = this;
    this._keyQueueCartUpdate = setTimeout(function() {
      self4.updateItems();
    }, this._timeWait);
  },
  /**
   * Increase item quantity 
   * @param {Integer} lineItemId 
   */
  increaseAction: function(lineItemId) {
    let qty = this.getItemQty(lineItemId);
    qty++;
    qty = qty < 99 ? qty : 99;
    this.getQtyInput(lineItemId).value = qty;
    this.queueUpdateItems();
  },
  /**
   * Decrease item quantity 
   * @param {Integer} lineItemId 
   */
  decreaseAction: function(lineItemId) {
    let qty = this.getItemQty(lineItemId);
    qty--;
    qty = qty < 1 ? 1 : qty;
    this.getQtyInput(lineItemId).value = qty;
    this.queueUpdateItems();
  },
  /**
   * Bind Remove Action
   */
  bindRemoveAction: function() {
    var self1 = this;
    document
    .getElementById(this._sliderContainer)
    .querySelectorAll(this._roleRemove)
    .forEach(function(target) {
      target.addEventListener('click', function(event) {
        self1.removeItem(event.currentTarget.getAttribute('data-target'));
      });
    });
  },
  /**
   * Bind Change Quantity Actions
   */
  bindQtyActions: function() {
    var self2 = this;
    let container = document.getElementById(this._sliderContainer);
    container.querySelectorAll(this._roleQtyPlus)
      .forEach(function(target) {
        target.addEventListener('click', function(event) {
          self2.increaseAction(event.currentTarget.getAttribute('data-target'));
        });
      });
    container.querySelectorAll(this._roleQtyMinus)
      .forEach(function(target) {
        target.addEventListener('click', function(event) {
          self2.decreaseAction(event.currentTarget.getAttribute('data-target'));
        });
      });
    container.querySelectorAll(this._roleQtyInput)
      .forEach(function(target) {
        target.addEventListener('blur', function(event) {
          self2.updateItems();
        });
        target.addEventListener('keyup', function(event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            self2.updateItems();
          }
        });
        target.addEventListener('focus', function(event) {
          event.currentTarget.select();
        });
      });
  },
  /**
   * Bind close actions
   */
  bindCloseActions: function() {
    var self3 = this;
    document.getElementById(this._sliderCloseIcon)
    .addEventListener('click', function(event) {
      self3.close();
    });
    document.getElementById(this._sliderShadow)
    .addEventListener('click', function(event) {
      self3.close();
    });
  },
  bindCartBagAction: function() {
    let cartBag = document.querySelector(this._roleCartBag);
    var self8 = this;
    cartBag.addEventListener('click', function(event) {
      event.preventDefault();
      self8.open();
    })
  },
  /**
   * Bind all cart events
   */
  bindActions: function() {
    this.bindQtyActions();
    this.bindRemoveAction();
    this.bindCloseActions();
    this.bindCartBagAction();
  },
  /**
   * Refresh cart content
   * @param {Boolean} anim 
   */
  refreshCart: async function(anim = false) {
    let response = await fetch('/?sections=cart-slider', {
      headers: { 'Accept': 'application/json'},
      method: 'GET'
    });
  
    if (response.ok) {
      let result = await response.json();
      if (result['cart-slider']) {
        document.getElementById(this._sliderCartWrapper).innerHTML = result['cart-slider'];
        this.init();
        this.open(anim);
      }
    }
    
    await this.refreshBagQty();
  },
  refreshBagQty: async function() {
    let response = await fetch('/cart.json', {
      headers: { 'Accept': 'application/json'},
      method: 'GET'
    });
  
    if (response.ok) {
      let result = await response.json();
      document.querySelector(this._roleCartBagQty).textContent = result.item_count ? parseInt(result.item_count) : 0;
      document.querySelector(this._roleCartBagQty).parentNode.style.opacity = 1;      
    }
  },
  /**
   * Rebind Form Submit
   * @param {Object} form 
   */
  rebindFormSubmit: function(form) {
    form.removeEventListener('submit', this.addToCartEvent);
    form.addEventListener('submit', this.addToCartEvent);
  },
  /**
   * Add To Cart Event
   * @param {Object} event 
   */
  addToCartEvent: async function(event) {
    event.preventDefault();
    event.stopPropagation();

    let _form = event.currentTarget;
    let _qtyInput = _form.querySelector('[name="quantity"]');
    let _idInput =  _form.querySelector('[name="id"]');
    let variantId = _idInput ? _idInput.value : _form.getAttribute('data-productid');
    let qty = _qtyInput ? _qtyInput.value : 1;

    await CartSlider.post('/cart/add', {
      id: variantId,
      quantity: qty
    });
    CartSlider.refreshCart(true);
  },
  /**
   * Replace Action
   */
  replaceAddToCart: function() {
    var self5 = this;    
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      self5.rebindFormSubmit(form);
    });
    document.querySelectorAll('form[action="/cart/add.js"]').forEach(function(form) {
      self5.rebindFormSubmit(form);
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  window.CartSlider = CartSlider;
  window.CartSlider.init();
});